import React from "react";
import UploadProduct from "./uploadProduct";
import ProductList from "./ProductList";
import Support from "./Support";
import SellerQueries from "./SellerQueryController";
import SellerProfile from "./SellerProfile";
import OrdersPage from "./OrderPage";
import ReturnOrders from "./ReturnOrders";
import CancelledOrders from "./CancelledOrders";
import PendingOrders from "./PendingOrders";
import CompletedOrders from "./CompletedOrders";

function Workspace({ activeTab, seller, token,editProduct, setEditProduct, setActiveTab }) {
  switch (activeTab) {
    case "orders-main":
      return <OrdersPage seller={seller} token={token} />;
    case "returns":
      return <ReturnOrders seller={seller} token={token} />;
    case "cancelled":
      return <CancelledOrders seller={seller} token={token} />;
    case "paymentPending":
      return <PendingOrders seller={seller} token={token} />;
    case "shipped": // if you later add shipped/completed
      return <CompletedOrders seller={seller} token={token} />;

    case "products":
      return <ProductList seller={seller} token={token} setEditProduct={setEditProduct}
          setActiveTab={setActiveTab}/>;
    case "uploadProduct":
      return <UploadProduct seller={seller} token={token}  editMode={!!editProduct}
         initialValues={editProduct}
      onSuccess={() => {setEditProduct(null);   setActiveTab("products")}}/>
    case "queries-raised":
      return <SellerQueries seller={seller} token={token} tabType="all" />;
    case "queries-replied":
      return <SellerQueries seller={seller} token={token} tabType="replied" />;

    case "profile":
      return <SellerProfile token={token} />;
    default:
      return <p>Select a section to view details.</p>;
  }
}

export default Workspace;
